<template>
    <section>
        <vip-sonko-drawer></vip-sonko-drawer>
        <v-content>
            <v-container fill-height>
                <v-layout row wrap>
                  <v-flex sm12 md4 lg4 class="sidebar">
                       <sidebar></sidebar>
                  </v-flex>
                  <v-flex sm12 md8 lg8>  <slot></slot> </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <expert-footer></expert-footer>
    </section>
</template>

<script>
import VipSonkoDrawer from '@/components/layout/vip_sonko_drawer.vue'
import Sidebar from "@/components/vip_sonko_sidebar/index.vue";
import ExpertFooter from "@/components/layout/expert_footer.vue";
export default {
  name: 'VIPSonkoLayout',
  components: {
    VipSonkoDrawer,
    Sidebar,
    ExpertFooter
  }
}
</script>
